/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AuthToken } from '../model';
// @ts-ignore
import type { CreateToken } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { LogoutResponse } from '../model';
// @ts-ignore
import type { Token } from '../model';
// @ts-ignore
import type { TokenResponse } from '../model';
// @ts-ignore
import type { TokenStatus } from '../model';
/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handles the OIDC callback — exchanges code for tokens, establishes session.
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAuthCallbackGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an API token for the current user.
         * @summary Create Api Token
         * @param {CreateToken} createToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiTokenAuthApiPost: async (createToken: CreateToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createToken' is not null or undefined
            assertParamExists('createApiTokenAuthApiPost', 'createToken', createToken)
            const localVarPath = `/auth/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an API token for the current user.
         * @summary Delete Api Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiTokenAuthApiDelete: async (tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('deleteApiTokenAuthApiDelete', 'tokenId', tokenId)
            const localVarPath = `/auth/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tokenId !== undefined) {
                localVarQueryParameter['token_id'] = tokenId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all API tokens for the current user.
         * @summary Get Api Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiTokensAuthApiGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of the current user\'s token.
         * @summary Get Token Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenStatusAuthTokenStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/token/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logged Out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggedOutAuthLoggedOutGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logged-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates the OIDC Authorization Code Flow for login via Authlib.
         * @summary Login
         * @param {boolean} [reauthenticate] 
         * @param {string | null} [returnTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthLoginGet: async (reauthenticate?: boolean, returnTo?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reauthenticate !== undefined) {
                localVarQueryParameter['reauthenticate'] = reauthenticate;
            }

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates the OIDC Authorization Code Flow for signup (with invite token).
         * @summary Login Signup
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSignupAuthLoginTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('loginSignupAuthLoginTokenGet', 'token', token)
            const localVarPath = `/auth/login/{token}`
                .replace('{token}', encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout: clear server-side session and return the OIDC provider logout URL.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAuthLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh the session JWT using the opaque refresh token.  The (possibly expired) access JWT must be in the Authorization header so we can extract the session ID.
         * @summary Refresh Session Token
         * @param {string} grantType 
         * @param {string} refreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSessionTokenAuthRefreshPost: async (grantType: string, refreshToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantType' is not null or undefined
            assertParamExists('refreshSessionTokenAuthRefreshPost', 'grantType', grantType)
            // verify required parameter 'refreshToken' is not null or undefined
            assertParamExists('refreshSessionTokenAuthRefreshPost', 'refreshToken', refreshToken)
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }

            if (refreshToken !== undefined) { 
                localVarFormParams.set('refresh_token', refreshToken as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange a one-time authorization code for session tokens.  The code is single-use and short-lived (60s). It was issued by the OIDC callback to avoid putting tokens in the redirect URL.
         * @summary Token Exchange
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchangeAuthTokenExchangePost: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('tokenExchangeAuthTokenExchangePost', 'code', code)
            const localVarPath = `/auth/token-exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Handles the OIDC callback — exchanges code for tokens, establishes session.
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackAuthCallbackGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackAuthCallbackGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.callbackAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an API token for the current user.
         * @summary Create Api Token
         * @param {CreateToken} createToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiTokenAuthApiPost(createToken: CreateToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiTokenAuthApiPost(createToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.createApiTokenAuthApiPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an API token for the current user.
         * @summary Delete Api Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiTokenAuthApiDelete(tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiTokenAuthApiDelete(tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.deleteApiTokenAuthApiDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all API tokens for the current user.
         * @summary Get Api Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiTokensAuthApiGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Token>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiTokensAuthApiGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getApiTokensAuthApiGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of the current user\'s token.
         * @summary Get Token Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenStatusAuthTokenStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenStatusAuthTokenStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getTokenStatusAuthTokenStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logged Out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loggedOutAuthLoggedOutGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loggedOutAuthLoggedOutGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loggedOutAuthLoggedOutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates the OIDC Authorization Code Flow for login via Authlib.
         * @summary Login
         * @param {boolean} [reauthenticate] 
         * @param {string | null} [returnTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAuthLoginGet(reauthenticate?: boolean, returnTo?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAuthLoginGet(reauthenticate, returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginAuthLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates the OIDC Authorization Code Flow for signup (with invite token).
         * @summary Login Signup
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSignupAuthLoginTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSignupAuthLoginTokenGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginSignupAuthLoginTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Logout: clear server-side session and return the OIDC provider logout URL.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutAuthLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutAuthLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.logoutAuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh the session JWT using the opaque refresh token.  The (possibly expired) access JWT must be in the Authorization header so we can extract the session ID.
         * @summary Refresh Session Token
         * @param {string} grantType 
         * @param {string} refreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshSessionTokenAuthRefreshPost(grantType: string, refreshToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshSessionTokenAuthRefreshPost(grantType, refreshToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshSessionTokenAuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange a one-time authorization code for session tokens.  The code is single-use and short-lived (60s). It was issued by the OIDC callback to avoid putting tokens in the redirect URL.
         * @summary Token Exchange
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenExchangeAuthTokenExchangePost(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenExchangeAuthTokenExchangePost(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.tokenExchangeAuthTokenExchangePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Handles the OIDC callback — exchanges code for tokens, establishes session.
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAuthCallbackGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.callbackAuthCallbackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Create an API token for the current user.
         * @summary Create Api Token
         * @param {AuthenticationApiCreateApiTokenAuthApiPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiTokenAuthApiPost(requestParameters: AuthenticationApiCreateApiTokenAuthApiPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthToken> {
            return localVarFp.createApiTokenAuthApiPost(requestParameters.createToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an API token for the current user.
         * @summary Delete Api Token
         * @param {AuthenticationApiDeleteApiTokenAuthApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiTokenAuthApiDelete(requestParameters: AuthenticationApiDeleteApiTokenAuthApiDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiTokenAuthApiDelete(requestParameters.tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all API tokens for the current user.
         * @summary Get Api Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiTokensAuthApiGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Token>> {
            return localVarFp.getApiTokensAuthApiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of the current user\'s token.
         * @summary Get Token Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenStatusAuthTokenStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<TokenStatus> {
            return localVarFp.getTokenStatusAuthTokenStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logged Out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggedOutAuthLoggedOutGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.loggedOutAuthLoggedOutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates the OIDC Authorization Code Flow for login via Authlib.
         * @summary Login
         * @param {AuthenticationApiLoginAuthLoginGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthLoginGet(requestParameters: AuthenticationApiLoginAuthLoginGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.loginAuthLoginGet(requestParameters.reauthenticate, requestParameters.returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates the OIDC Authorization Code Flow for signup (with invite token).
         * @summary Login Signup
         * @param {AuthenticationApiLoginSignupAuthLoginTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSignupAuthLoginTokenGet(requestParameters: AuthenticationApiLoginSignupAuthLoginTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.loginSignupAuthLoginTokenGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout: clear server-side session and return the OIDC provider logout URL.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<LogoutResponse> {
            return localVarFp.logoutAuthLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh the session JWT using the opaque refresh token.  The (possibly expired) access JWT must be in the Authorization header so we can extract the session ID.
         * @summary Refresh Session Token
         * @param {AuthenticationApiRefreshSessionTokenAuthRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSessionTokenAuthRefreshPost(requestParameters: AuthenticationApiRefreshSessionTokenAuthRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.refreshSessionTokenAuthRefreshPost(requestParameters.grantType, requestParameters.refreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange a one-time authorization code for session tokens.  The code is single-use and short-lived (60s). It was issued by the OIDC callback to avoid putting tokens in the redirect URL.
         * @summary Token Exchange
         * @param {AuthenticationApiTokenExchangeAuthTokenExchangePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchangeAuthTokenExchangePost(requestParameters: AuthenticationApiTokenExchangeAuthTokenExchangePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.tokenExchangeAuthTokenExchangePost(requestParameters.code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createApiTokenAuthApiPost operation in AuthenticationApi.
 */
export interface AuthenticationApiCreateApiTokenAuthApiPostRequest {
    readonly createToken: CreateToken
}

/**
 * Request parameters for deleteApiTokenAuthApiDelete operation in AuthenticationApi.
 */
export interface AuthenticationApiDeleteApiTokenAuthApiDeleteRequest {
    readonly tokenId: string
}

/**
 * Request parameters for loginAuthLoginGet operation in AuthenticationApi.
 */
export interface AuthenticationApiLoginAuthLoginGetRequest {
    readonly reauthenticate?: boolean

    readonly returnTo?: string | null
}

/**
 * Request parameters for loginSignupAuthLoginTokenGet operation in AuthenticationApi.
 */
export interface AuthenticationApiLoginSignupAuthLoginTokenGetRequest {
    readonly token: string
}

/**
 * Request parameters for refreshSessionTokenAuthRefreshPost operation in AuthenticationApi.
 */
export interface AuthenticationApiRefreshSessionTokenAuthRefreshPostRequest {
    readonly grantType: string

    readonly refreshToken: string
}

/**
 * Request parameters for tokenExchangeAuthTokenExchangePost operation in AuthenticationApi.
 */
export interface AuthenticationApiTokenExchangeAuthTokenExchangePostRequest {
    readonly code: string
}

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Handles the OIDC callback — exchanges code for tokens, establishes session.
     * @summary Callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public callbackAuthCallbackGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).callbackAuthCallbackGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an API token for the current user.
     * @summary Create Api Token
     * @param {AuthenticationApiCreateApiTokenAuthApiPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createApiTokenAuthApiPost(requestParameters: AuthenticationApiCreateApiTokenAuthApiPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).createApiTokenAuthApiPost(requestParameters.createToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an API token for the current user.
     * @summary Delete Api Token
     * @param {AuthenticationApiDeleteApiTokenAuthApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteApiTokenAuthApiDelete(requestParameters: AuthenticationApiDeleteApiTokenAuthApiDeleteRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).deleteApiTokenAuthApiDelete(requestParameters.tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all API tokens for the current user.
     * @summary Get Api Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiTokensAuthApiGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getApiTokensAuthApiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of the current user\'s token.
     * @summary Get Token Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTokenStatusAuthTokenStatusGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getTokenStatusAuthTokenStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logged Out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loggedOutAuthLoggedOutGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loggedOutAuthLoggedOutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates the OIDC Authorization Code Flow for login via Authlib.
     * @summary Login
     * @param {AuthenticationApiLoginAuthLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginAuthLoginGet(requestParameters: AuthenticationApiLoginAuthLoginGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginAuthLoginGet(requestParameters.reauthenticate, requestParameters.returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates the OIDC Authorization Code Flow for signup (with invite token).
     * @summary Login Signup
     * @param {AuthenticationApiLoginSignupAuthLoginTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginSignupAuthLoginTokenGet(requestParameters: AuthenticationApiLoginSignupAuthLoginTokenGetRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginSignupAuthLoginTokenGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout: clear server-side session and return the OIDC provider logout URL.
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public logoutAuthLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logoutAuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh the session JWT using the opaque refresh token.  The (possibly expired) access JWT must be in the Authorization header so we can extract the session ID.
     * @summary Refresh Session Token
     * @param {AuthenticationApiRefreshSessionTokenAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshSessionTokenAuthRefreshPost(requestParameters: AuthenticationApiRefreshSessionTokenAuthRefreshPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshSessionTokenAuthRefreshPost(requestParameters.grantType, requestParameters.refreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange a one-time authorization code for session tokens.  The code is single-use and short-lived (60s). It was issued by the OIDC callback to avoid putting tokens in the redirect URL.
     * @summary Token Exchange
     * @param {AuthenticationApiTokenExchangeAuthTokenExchangePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenExchangeAuthTokenExchangePost(requestParameters: AuthenticationApiTokenExchangeAuthTokenExchangePostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).tokenExchangeAuthTokenExchangePost(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}

